import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "font-mono" }
const _hoisted_3 = {
  key: 0,
  class: "font-bold text-red-600 text-xl"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "ml-auto flex items-center" }

import { computed } from 'vue'
import { version } from '@/main'


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const isTestEnvironment = computed(() => window.location.hostname.includes("forms-test"));

const greeting = computed(() => {
  const hour = new Date().getHours();

  if (hour >= 0 && hour < 6) return "Goedenacht";
  if (hour >= 6 && hour < 12) return "Goedemorgen";
  if (hour >= 12 && hour < 18) return "Goedemiddag";

  return "Goedeavond";
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isTestEnvironment.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " JE BENT MOMENTEEL IN DE TEST OMGEVING!!! "))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(greeting.value) + ", collega!", 1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_RouterLink, {
        to: { name: 'Admin.Information' },
        class: "inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-sm font-medium text-blue-700 ring-1 ring-blue-700/10 ring-inset"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" v" + _toDisplayString(_unref(version)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})